import type { RouteObject } from "react-router-dom";
import { PagesBlogManagerUiDisplay } from "./Display";
import { PagesBlogManagerUiResults } from "./Display/Results";
import { PagesBlogManagerUiModal } from "./Display/Modal";

export const PagesBlogManagerUiRoutes: RouteObject[] = [
  {
    path: "blogManager",
    element: <PagesBlogManagerUiDisplay />,
    children: [
      {
        path: ":searchValue",
        element: <PagesBlogManagerUiResults />,
        children: [
          {
            path: ":record",
            element: <PagesBlogManagerUiModal />
          }
        ]
      }
    ]
  }
];
